<template>
  <div class="header-wrapper df fdr jcsb aic w100p" v-bind:class="{
    'header-wrapper-live': $route.name == 'LivePage'
  }">

    <!-- 'abc' -->

    <div class="header-inner f1 df aic jcsb w100p">
      <div v-if="!sidebarShown && ($route.name !== 'LivePage')" @click="showSidebar()">
        <img class="icon2 curp" src="../../static/images/new-icon-menu-button.svg">
      </div>
      <img src="../../static/images/cup-wise-logo.svg" class="header-logo curp" @click="goTo(($route.name == 'LivePage' ? '/me' : '/'), true)">
      <p class="cupwise curp" @click="goTo(($route.name == 'LivePage' ? '/me' : '/'), true)"><span>Cup</span>Wise{{$store.getters['AUTH.myPrivateData'].type == 'pro' ? ' Pro' : ''}}</p>
      <div class="f1"></div>
      <div v-if="showUserMenu && !$store.getters['AUTH.anonUser']" class="name-plus-initial posrel">
        <div class="initial curp">{{initial(this.$store.getters['AUTH.myPublicData'].displayName || ' ')}}</div>
        <p class="name curp">{{this.$store.getters['AUTH.myPublicData'].displayName || 'Settings'}}</p>
        <img class="chevron-down chevron-up curp" src="../../static/images/new-icon-chevron-down-small.svg"></img>
        <div class="user-menu" v-click-outside:delay="closeUserMenu">
          <span class="df curp menu-option" @click="goTo('/settings')">
            <div class="icon icon-profile"></div>
            <p>Your Profile</p>
          </span>
          <hr class="hr1"/>
          <span class="df curp menu-option" @click="logout()">
            <div class="icon icon-logout"></div>
            <p>Logout</p>
          </span>
        </div>
      </div>
      <div v-else class="name-plus-initial posrel">
        <div class="initial curp" @click="openUserMenu()">{{initial(this.$store.getters['AUTH.myPublicData'].displayName || '  ')}}</div>
        <p @click="registerAndGoBack()" v-if="$store.getters['AUTH.anonUser']" class="name curp name-small df fdc">
          <span>Sign in</span>
          <span>to save</span>
        </p>
        <p @click="registerAndGoBack()" v-if="$store.getters['AUTH.anonUser']" class="name curp name-big">
          <span>Sign in</span>
          <span>to save scores</span>
        </p>
        <p v-else-if="$store.getters['AUTH.myPublicData'].displayName" class="name curp" @click="openUserMenu()">{{$store.getters['AUTH.myPublicData'].displayName}}</p>
        <p v-else class="name curp" @click="openUserMenu()">{{'Settings'}}</p>
        <!-- <p v-else class="name curp" @click="openUserMenu()">{{this.$store.getters['AUTH.myPublicData'].displayName ? 'Settings'}}</p> -->
        

        <img v-if="!$store.getters['AUTH.anonUser']" class="chevron-down curp" @click="openUserMenu()" src="../../static/images/new-icon-chevron-down-small.svg"/>
      </div>

      <!-- </a> -->
    </div>
  </div>
</template>

      <!-- <div class="f1 df jcfe aic bar-links"> -->
        <!-- <i @click="goTo('/sessions')" class="icon far fa-calendar-star"></i> -->
        <!-- <i @click="goTo('/templates')" class="icon far fa-tasks"></i> -->
        <!-- <i @click="goTo('/coffees')" class="icon far fa-coffee-pot"></i> -->
        <!-- <i @click="goTo('/settings')" class="icon far fa-cogs"></i> -->
        <!-- <i class="icon-coffee icon curp" @click="showCuppingSettings()"></i> -->
        <!-- <p class="logout" @click="logout()">Logout</p> -->
        <!-- <i class="icon-gear icon" @click="showSessionSettings()"></i> -->
      <!-- </div> -->

<script>
import router from '@/router'
import ShopProduct from '@/components/ShopProduct'
import ClickOutside from 'vue-click-outside'

export default {
  name: 'DashHeader',
  data () {
    return {
      some: 'data',
      showUserMenu: false
    }
  },
  props: ['mode', 'setSidebarShown', 'sidebarShown'],
  components: {
    ShopProduct
  },
  methods: {
    registerAndGoBack () {
      if (this.$route.params.liveSessionId) {
        router.push('/?auth=register&then=' + this.$route.params.liveSessionId)
      } else {
        router.push('/?auth=register')
      }
    },
    initial (text) {
      return text.substring(0,2).toUpperCase()
    },
    logout () {
      this.showUserMenu = false
      this.$store.dispatch('AUTH.logout', {})
    },
    openUserMenu () {
      console.log('open')
      setTimeout(() => {
        console.log('opened')
        this.showUserMenu = true
      }, 100)
    },
    closeUserMenu () {
      console.log('close')
      this.showUserMenu = false
    },
    showSidebar () {
      console.log('here')
      setTimeout(() => {
        this.setSidebarShown(true)
      }, 100)
    },
    logout () {
      this.$store.dispatch('AUTH.logout', {})
    },
    showCuppingSettings () {
      this.$store.dispatch('AUTH.showCuppingSettings', true)
    },
    hide () {
      this.$store.dispatch('AUTH.showHeaderShop', false)
    },
    goTo (path, showSidebar) {
      this.$store.dispatch('AUTH.showHeaderShop', false)
      this.showUserMenu = false
      router.push(path)
      if (showSidebar) {
        this.showSidebar()
      }
    },
    showShop (event) {
      event.stopPropagation()
      this.$store.dispatch('AUTH.showHeaderShop', !this.$store.getters['AUTH.showHeaderShop'])
    },
    goToPrevious () {
      router.push('/previous')
    },
    goToLive () {
      router.push('/live')
    },
    goToAccount () {
      let uid = this.$store.getters['AUTH.uid']
      if (uid) {
        router.push('/myaccount')
      } else {
        router.push('/login')
      }
    }
  },
  computed: {

  },
  watch: {
  },
  mounted () {
  },
  directives: {
    ClickOutside
  },
  created () {
    // console.log('...route', this.$route)
  }
}
</script>

<style scoped lang="scss">
  @import "../styles/settings.scss";
  h1, h2, h3, h4, h5, h6, h7, h8 {
    font-weight: 600,
  }
  $header-height: 79px;
  .header-wrapper {
    /*background-color: #efeff0;*/
    height: $header-height;
    // padding-left: 15px;
    // padding-right: 15px;
    z-index: 1;
  }
  .header-inner {
    padding-left: 15px;
    padding-right: 15px;
    height: 100%;
    // border-bottom-left-radius: 5px;
    // border-bottom-right-radius: 5px;
    /*width: calc(100% - 30px);*/
  }
  .bar-links {
    font-size: 14px;
  }
  .shop-dropdown {
    position: absolute;
    top: 145px;
    left: 0;
    width: 100%;
    height: 355px;
    background-color: #1E1F20;
  }
  .shop-dropdown-wrapper {
    max-width: $max-width;
  }
  .red-dot {
    display: inline-block;
    min-height: 15px;
    min-width: 15px;
    border-radius: 6px;
    background-color: red;
    margin-right: 8px;
    padding: 5px;
    font-weight: 600;
  }
  .powered-by {
    font-size: 12px;
    margin-bottom: 10px;
  }
  .taste-together {
    font-size: 14px;
  }
  .inverted-colors {
    .header-inner {
      background-color: #fff;
      /*border-bottom: 1px solid #DBDBDB;*/
      /*background-color: #efeff0;*/
    }
    .cupwise {
      color: #000000;
      font-family: Inter;
      font-size: 16px;
      font-weight: 300;
      letter-spacing: 0;
      line-height: 20px;
      margin-left: 6px;

      span {
        font-weight: 800;
      }
    }
  }

  .icon-gear, .icon-coffee {
    font-size: 22px;
    opacity: 0.75;
  }
  .logout {
    cursor: pointer;
    font-size: 12px;
    margin-left: 20px;
  }
  @media (max-width: 1200px) {
    .header-wrapper-live {
      height: 60px;
    }
  }
  @media (max-width: 420px) {
    .header-wrapper {
      padding-left: 0;
      padding-right: 0;
      .header-inner {
        border-radius: 0;
      }
    }
  }
  .icon2 {
    margin-right: 28px;
    cursor: pointer;
  }
  .fa-bars {
    font-size: 25px;
    margin-right: 10px !important;
    cursor: pointer;
  }
  .fa-cogs {
    font-size: 18px;
    cursor: pointer;
  }
  .header-logo {
    width: 48px;
    height: 41px;
  }
  .user-menu {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    padding: 17px 15px 19px;
    border-radius: 5px;
    box-shadow: 0 0 5px 0 rgba(164,164,164,0.5);
    background-color: #fff;
    min-width: 148px;

    & > span {
      display: flex;
      align-items: center;
      img {
        margin-right: 11px;
      }
      p {
        color: #5C5C5C;
        font-family: Inter;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: 0;
        line-height: 16px;
      }
    }
  }
  .hr1 {
    background-color: #979797;
    margin-top: 17px;
    margin-bottom: 11x;
  }

  .icon {
    width: 18px;
    height: 20px;
    margin-right: 11px;
    background-position: center !important;
    background-repeat: no-repeat !important;
    &:before {
      display: none;
    }
  }
  
  .icon-profile {
    background: url('../../static/images/icon-new-profile.svg');
  }
  .icon-logout {
    background: url('../../static/images/icon-new-logout.svg');
  }
  .icon-settings {
    background: url('../../static/images/icon-new-settings.svg');
  }
  .menu-option {
    &:hover {
      p {
        color: $color-primary;
      }
      .icon-profile {
        background: url('../../static/images/icon-new-profile-active.svg');
      }
      .icon-logout {
        background: url('../../static/images/icon-new-logout-active.svg');
      }
      .icon-settings {
        background: url('../../static/images/icon-new-settings-active.svg');
      }
    }
  }
  .chevron-up {
    transform: rotate(180deg);
  }
  .name-plus-initial {
    min-width: 181px;
    justify-content: flex-end;
  }

  .name-big {
    span {
      &:last-child {
        /*font-size: 12px;*/
        font-weight: 400;
      }
    }
  }

  .name-small {
    display: none;
    text-align: center;
    span {
      &:last-child {
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
  @media (max-width: 435px) {
    .icon2 {
      margin-right: 14px;
    }
    .name {
      max-width: 100px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .name-plus-initial {
      min-width: unset;
    }
    .name-big {
      display: none;
    }
    .name-small {
      display: flex;
    }
  }

  @media (max-width: 390px) {
    .icon2 {
      margin-right: 14px;
    }
    .name {
      max-width: 60px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/DashHeader.vue